"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateEmailChannelPayload = exports.EmailChannel = exports.ChannelId = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../date");
const net_1 = require("../net");
const User = __importStar(require("./user"));
exports.NAMESPACE = 'Culligan.NotificationChannel';
exports.ChannelId = effect_1.Schema.NonEmptyString.annotations({
    identifier: `${exports.NAMESPACE}.ChannelId`,
    description: 'Notification channel identifier',
});
exports.EmailChannel = effect_1.Schema.Struct({
    id: exports.ChannelId,
    createdAt: effect_1.Schema.optionalWith(date_1.DateFromUtcIsoDateString, { exact: true }),
    updatedAt: effect_1.Schema.optionalWith(date_1.DateFromUtcIsoDateString, { exact: true }),
    userId: User.Id,
    appId: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: 'Client application identifier (internal)',
    }),
    type: effect_1.Schema.Literal('email'),
    active: effect_1.Schema.Boolean,
    email: net_1.Email,
    name: effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString),
}).annotations({
    identifier: `${exports.NAMESPACE}.EmailChannel`,
    description: 'An e-mail notification channel',
});
exports.CreateEmailChannelPayload = effect_1.Schema.Struct({
    email: net_1.Email,
    name: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.CreateEmailChannelPayload`,
    description: 'Payload for creating or updating an e-mail notification channel',
});
//# sourceMappingURL=notification-channel.js.map